import React from 'react';

import styles from './style.scss';


const BookHasNotReviews = ({ children }) => {
  return (
    <div className={styles.content}>
      <div className="sectionHeader">
        <h1>{children}</h1>
      </div>
      <div className={styles.image} />
    </div>
  );
};

export default BookHasNotReviews;
